<template>
  <div class="flex-1 overflow-auto p-4 flex justify-between flex-col">
    <a @click.prevent="handleAddTemplateClick" class="button success button--fixed-top">
      <svg
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM12 7a.75.75 0 0 1 .75.75v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5a.75.75 0 0 1-1.5 0v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5A.75.75 0 0 1 12 7Z"
          fill="currentColor"
        ></path>
      </svg>
      <span class="button__content"> Add Whatsapp Templates </span>
    </a>
    <!-- <router-link
      :to="inboxTemplateUrl"
      class="button success button--fixed-top"
    >
      <fluent-icon icon="add-circle" />
      <span class="button__content"> Add Whatsapp Templates </span>
    </router-link> -->
    <!-- List Audit Logs -->
    <div class="divone">
      <div class="divtwo">
        <!-- Inbox Selector (shown when multiple WhatsApp inboxes exist and not in inbox-specific context) -->
        <div v-if="!$route.params.inboxId && whatsappInboxes.length > 1" class="inbox-selector-row">
          <div class="inbox-selector">
            <label>Select Inbox:</label>
            <div class="custom-dropdown" :class="{ 'is-open': isInboxDropdownOpen }">
              <div class="dropdown-trigger" @click="toggleInboxDropdown">
                <span>{{ selectedInboxName }}</span>
                <fluent-icon icon="chevron-down" size="14" />
              </div>
              <div v-if="isInboxDropdownOpen" class="dropdown-menu">
                <div
                  v-for="inbox in whatsappInboxes"
                  :key="inbox.id"
                  class="dropdown-item"
                  :class="{ 'is-selected': selectedInbox === inbox.id }"
                  @click="selectInbox(inbox.id)"
                >
                  {{ inbox.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Filter Tabs, Search Bar and Sync Button in one line -->
        <div class="main-header">
          <div class="header-left">
            <div class="filter-tabs">
              <button
                v-for="tab in filterTabs"
                :key="tab.key"
                class="filter-tab"
                :class="{ 'filter-tab--active': activeFilter === tab.key }"
                @click="onFilterChange(tab.key)"
              >
                {{ tab.label }}
              </button>
            </div>
            <div class="template-search-wrap">
              <div class="search-icon-wrap" @click="onSearchSubmit">
                <fluent-icon
                  icon="search"
                  class="search-icon"
                />
              </div>
              <input
                type="text"
                placeholder="Search templates by name..."
                class="template-search-input"
                :value="searchQuery"
                @keyup.enter="onSearchSubmit"
                @input="onSearchInput"
              />
            </div>
          </div>
          <div class="sync-button">
            <woot-button color-scheme="primary" @click="syncData">Sync Data</woot-button>
          </div>
        </div>
        
        <div v-if="!isSyncing && !loading && templates.length" class="table-wrapper">
          <table class="whatsapp">
            <thead>
              <tr>
                <th>NAME</th>
                <th>MESSAGE TYPE</th>
                <th>LANGUAGE</th>
                <th>STATUS</th>
                <th class="text-center">ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="template in templates" :key="template.id">
                <td data-label="NAME">{{ template.name }}</td>
                <td data-label="MESSAGE TYPE">{{ template.category }}</td>
                <td data-label="LANGUAGE">{{ template.language }}</td>
                <td data-label="STATUS">{{ template.status }}</td>

                <td data-label="ACTION" class="action-cell">
                  <div class="action-buttons flex justify-center gap-2">
                    <template v-if="activeFilter === 'archived'">
                      <woot-button
                        v-tooltip.top-end="'Restore'"
                        size="tiny"
                        variant="smooth"
                        icon="arrow-clockwise"
                        color-scheme="primary"
                        @click="restoreTemplate(template)"
                      />
                    </template>
                    <template v-else>
                      <woot-button
                        v-if="template.status == 'APPROVED'"
                        v-tooltip.top-end="'Edit'"
                        size="tiny"
                        variant="smooth"
                        icon="edit"
                        @click="viewCategory(template.id)"
                      />

                      <!--<woot-button
                        v-tooltip.top-end="'Edit'"
                        size="tiny"
                        variant="smooth"
                        icon="edit"
                        color-scheme="secondary"
                        @click="editCategory(template.id)"
                      /> -->

                      <woot-button
                        v-tooltip.top-end="'Archive'"
                        size="tiny"
                        variant="smooth"
                        icon="archive"
                        color-scheme="secondary"
                        @click="openDeleteModal(template)"
                      />
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="no-data text-center" v-if="initialLoadComplete && !isSyncing && !loading && templates.length === 0">
          No Whatsapp Template Found
        </p>
        
        <div v-if="isSyncing || loading" class="notifications--loader">
          <spinner size="large" color-scheme="primary" />
          <span>{{ $t('NOTIFICATIONS_PAGE.LIST.WHATSAPP_MESSAGE') }}</span>
        </div>
        <div v-if="isLoading" class="template--loader">
          <spinner size="large" color-scheme="primary" />
          <span class="text-white">{{ dynamicText }}</span>
        </div>
      </div>
    </div>
    <!-- Sticky footer at bottom of page (like contacts table) -->
    <div
      v-if="!isSyncing && !loading && templates.length > 0"
      class="table-footer-wrap table-footer-sticky"
    >
      <table-footer
        :current-page="currentPage"
        :page-size="perPage"
        :total-count="totalCount"
        @page-change="onPageChange"
      />
    </div>



 <woot-modal v-if="showPopup" :show.sync="showPopup" :on-close="closeConfirmModal">
  <woot-modal-header header-title="Select Inbox" />
  <div class="px-8 pb-4 inbox-selection-modal">
    <p>Please select a inbox to create whatsapp template</p>

          <multiselect
            v-model="selectedTemplateType"
            :options="whatsappInboxes"
            track-by="id"
            label="name"
            placeholder="Select a Inbox"
            :allow-empty="true"
            :close-on-select="true"
            select-label=""
            deselect-label=""
            selected-label=""
          />
        <div class="flex justify-end mt-4">
          <woot-button variant="clear" @click="closeConfirmModal">
            CANCEL
          </woot-button>
          <woot-button class="confirm" @click="onConfirmModalSubmit">
            CONFIRM
          </woot-button>
        </div>
  </div>
  
</woot-modal>

    <!-- Archive Confirmation Modal -->
    <woot-modal v-if="showDeleteModal" :show.sync="showDeleteModal" :on-close="closeDeleteModal">
      <woot-modal-header header-title="Archive Template" />
      <div class="delete-modal-content px-8 pb-4">
        <p class="delete-message">
          {{ deleteModalMessage }}
          <strong>{{ selectedTemplateForDelete?.name }}</strong>
        </p>
        
        <!-- Loading state while checking usage -->
        <div v-if="isCheckingUsage" class="usage-loading">
          <spinner size="small" />
          <span class="text-sm text-slate-600">Checking template usage...</span>
        </div>
        
        <!-- Show affected macros and campaigns if any -->
        <div v-if="!isCheckingUsage && templateUsage && templateUsage.in_use">
          <div class="usage-details">
            <div v-if="templateUsage.macro_count > 0" class="usage-section">
              <h4 class="usage-title">Affected Macros ({{ templateUsage.macro_count }})</h4>
              <ul class="usage-list">
                <li v-for="macro in templateUsage.macro_names" :key="macro">{{ macro }}</li>
              </ul>
            </div>
            
            <div v-if="templateUsage.campaign_count > 0" class="usage-section">
              <h4 class="usage-title">Affected Campaigns ({{ templateUsage.campaign_count }})</h4>
              <ul class="usage-list">
                <li v-for="campaign in templateUsage.campaign_names" :key="campaign">{{ campaign }}</li>
              </ul>
            </div>
          </div>
          
          <div v-if="templateUsage.active_campaign_count > 0" class="critical-warning">
            <strong>⚠️ CRITICAL:</strong> {{ templateUsage.active_campaign_count }} active campaign(s) will stop sending messages!
            <ul class="usage-list mt-2">
              <li v-for="campaign in templateUsage.active_campaign_names" :key="campaign">{{ campaign }}</li>
            </ul>
          </div>
        </div>
        
        <div class="flex justify-end mt-4 gap-2">
          <woot-button variant="clear" @click="closeDeleteModal">
            Cancel
          </woot-button>
          <woot-button 
            class="archive-button" 
            :disabled="isCheckingUsage"
            @click="confirmDeleteTemplate"
          >
            Archive
          </woot-button>
        </div>
      </div>
    </woot-modal>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import accountMixin from '../../../../mixins/account';
import alertMixin from 'shared/mixins/alertMixin';
import adminMixin from '../../../../mixins/isAdmin';
import Spinner from 'shared/components/Spinner.vue';
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';
import fetchSecretMixin from 'shared/mixins/fetchSecret';
import { ca } from 'date-fns/locale';

export default {
  components: { Spinner, TableFooter },
  mixins: [accountMixin, alertMixin, adminMixin, fetchSecretMixin],
  data() {
    return {
      loading: false,
      showSettings: false,
      showDeletePopup: false,
      showTable: false,
      templates: [],
      phoneNumber: '',
      showEditModal: false,
      showViewModal: false,
      closeEditModal: true,
      closeViewModal: true,
      selectedTemplateId: null,
      deletebutton: false,
      dynamicText: '',
      activeFilter: 'all',
      searchQuery: '',
      lastAppliedSearchQuery: '',
      filterTabs: [
        { key: 'all', label: 'All' },
        { key: 'approved', label: 'Active' },
        { key: 'pending', label: 'Pending' },
        { key: 'rejected', label: 'Rejected' },
        { key: 'archived', label: 'Archived' },
      ],
      showPopup: false,
      selectedTemplateType: [],
      // Pagination
      currentPage: 1,
      perPage: 15,
      totalPages: 1,
      totalCount: 0,
      hasNextPage: false,
      hasPrevPage: false,
      // Dropdown states
      isPerPageDropdownOpen: false,
      isInboxDropdownOpen: false,
      selectedInbox: null,
      perPageOptions: [10, 15, 25, 50, 100],
      // Track whether the first data fetch has completed
      initialLoadComplete: false,
      // Delete modal
      showDeleteModal: false,
      selectedTemplateForDelete: null,
      isDeleting: false,
      templateUsage: null,
      isCheckingUsage: false,
      isSyncing: false,
      refreshAfterCreateTimer: null,
    };
  },
  // props: {
  //   inbox: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    ...mapGetters({
      templateLists: 'whatsappTemplates/getTemplates',
      currentAccountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      uiFlags: 'whatsappTemplates/getUIFlags',
      whatsappInboxes: "inboxes/getWhatsappInboxes"
    }),
    // inboxTemplateUrl() {
    //   return `/app/accounts/${this.$route.params.accountId}/settings/inboxes/${this.$route.params.inboxId}/whatsapp_template/add_contents`;
    // },
    isLoading() {
      return this.uiFlags.isDeleting || this.uiFlags.isFetching || this.isDeleting;
    },
    paginationStart() {
      if (this.totalCount === 0) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    paginationEnd() {
      const end = this.currentPage * this.perPage;
      return end > this.totalCount ? this.totalCount : end;
    },
    selectedInboxName() {
      if (!this.selectedInbox) return 'Select Inbox';
      const inbox = this.whatsappInboxes.find(i => i.id === this.selectedInbox);
      return inbox ? inbox.name : 'Select Inbox';
    },
    deleteModalMessage() {
      return 'Are you sure you want to archive the template?';
    },
  },
  async mounted() {
    // Wait for inboxes to be loaded first
    await this.$store.dispatch('inboxes/get');
    
    // Initialize selected inbox
    const routeInboxId = this.$route.params.inboxId;
    if (routeInboxId) {
      this.selectedInbox = Number(routeInboxId);
    } else if (this.whatsappInboxes.length > 0) {
      this.selectedInbox = this.whatsappInboxes[0].id;
    }
    
    // Add click listener to close dropdowns when clicking outside
    document.addEventListener('click', this.handleOutsideClick);
    
    await this.syncData();

    // After creating a template, sync runs async on the server; refetch list once
    // so the new template appears without requiring a manual Sync click
    if (this.$route.query.from === 'create') {
      this.refreshAfterCreateTimer = setTimeout(() => {
        this.refreshAfterCreateTimer = null;
        this.fetchTemplates(1);
        this.$router.replace({
          name: 'whatsapp_template_list',
          params: this.$route.params,
          query: {},
        }).catch(() => {});
      }, 3500);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    if (this.refreshAfterCreateTimer) {
      clearTimeout(this.refreshAfterCreateTimer);
      this.refreshAfterCreateTimer = null;
    }
  },
  methods: {
    // Dropdown toggle methods
    togglePerPageDropdown() {
      this.isPerPageDropdownOpen = !this.isPerPageDropdownOpen;
      this.isInboxDropdownOpen = false; // Close other dropdown
    },
    toggleInboxDropdown() {
      this.isInboxDropdownOpen = !this.isInboxDropdownOpen;
      this.isPerPageDropdownOpen = false; // Close other dropdown
    },
    selectPerPage(value) {
      this.perPage = value;
      this.isPerPageDropdownOpen = false;
      this.onPerPageChange();
    },
    selectInbox(inboxId) {
      this.selectedInbox = inboxId;
      this.isInboxDropdownOpen = false;
      this.syncData(); // Reload templates for selected inbox
    },
    onFilterChange(filterKey) {
      this.activeFilter = filterKey;
      this.currentPage = 1;
      this.fetchTemplates(1);
    },
    onSearchInput(event) {
      const newQuery = event.target.value;
      const wasSearching = !!this.lastAppliedSearchQuery;
      const isNowEmpty = newQuery.trim() === '';

      this.searchQuery = newQuery;

      if (wasSearching && isNowEmpty) {
        this.lastAppliedSearchQuery = '';
        this.currentPage = 1;
        this.fetchTemplates(1);
      }
    },
    onSearchSubmit() {
      const trimmedQuery = this.searchQuery.trim();
      if (trimmedQuery === this.lastAppliedSearchQuery) {
        return;
      }
      this.lastAppliedSearchQuery = trimmedQuery;
      this.currentPage = 1;
      this.fetchTemplates(1);
    },
    closeDropdowns() {
      this.isPerPageDropdownOpen = false;
      this.isInboxDropdownOpen = false;
    },
    handleOutsideClick(event) {
      const dropdowns = this.$el.querySelectorAll('.custom-dropdown');
      let clickedInside = false;
      dropdowns.forEach(dropdown => {
        if (dropdown.contains(event.target)) {
          clickedInside = true;
        }
      });
      if (!clickedInside) {
        this.closeDropdowns();
      }
    },

    inboxTemplateUrl() {
      return `/app/accounts/${this.$route.params.accountId}/settings/inboxes/${this.inboxId()}/whatsapp_template/add_contents`;
    },

    handleAddTemplateClick() {
      const inboxId = this.$route.params.inboxId;

        if (inboxId) {
          this.$router.push(this.inboxTemplateUrl());
        } else {
          this.showPopup = true;
        }
  },

  onConfirmModalSubmit() {
        if (!this.selectedTemplateType || !this.selectedTemplateType.id) {
        this.showAlert("please select a Inbox", { success: false });
          return;
        }

        this.showPopup = false;

        const accountId = this.$route.params.accountId;
        const inboxId = this.selectedTemplateType.id;

        const route = `/app/accounts/${accountId}/settings/inboxes/${inboxId}/whatsapp_template/add_contents`;
        this.$router.push(route);
  },

   closeConfirmModal() {
    this.showPopup = false;
  },
    
    async fetchInboxChannelApiKey() {
      try {
        const inboxId = this.selectedInbox || this.$route.params.inboxId;
        if (!inboxId) {
          console.log('No inbox selected');
          return null;
        }
        const response = await axios.get(
          `/api/v1/accounts/${this.currentAccountId}/inboxes/${inboxId}`,
          {
            headers: {
              'api-access-token': this.currentUser.access_token,
              'Content-Type': 'application/json',
            },
          }
        );
        const apiKey = response.data.provider_config.api_key;
        this.phoneNumber = response.data.phone_number;
        return response;
      } catch (error) {
        console.error('Error fetching inbox channel API keys:', error);
        return null;
      }
    },
    async fetchTemplates(page = this.currentPage) {
      try {
        this.loading = true;
        const inbox = await this.fetchInboxChannelApiKey();
        const keys = await this.getKeys();
        
        // Fetch templates from local database with pagination, filter and search
        const response = await this.$store.dispatch(
          'whatsappTemplates/fetchTemplates',
          {
            inbox: inbox,
            keys: keys,
            accountId: this.$route.params.accountId,
            page: page,
            perPage: this.perPage,
            status: this.activeFilter,
            search: this.searchQuery,
          }
        );

        if (response?.data?.data) {
          this.templates = response.data.data.map(template => ({
            id: template.id,           // WhatsApp template_id (for viewing/editing)
            db_id: template.db_id,     // Local DB id (for soft delete)
            name: template.name,
            language: template.language,
            status: template.status,
            category: template.category,
          }));
          
          // Update pagination meta
          if (response.data.meta) {
            this.currentPage = response.data.meta.current_page;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.hasNextPage = response.data.meta.has_next_page;
            this.hasPrevPage = response.data.meta.has_prev_page;
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.templates = [];
        console.error('Error fetching templates:', error);
      }
    },
    onPageChange(page) {
      this.fetchTemplates(page);
    },
    onPerPageChange() {
      this.currentPage = 1; // Reset to first page when changing per page
      this.fetchTemplates(1);
    },
    async syncData() {
      this.isSyncing = true;
      try {
        const access_token = this.currentUser.access_token;
        const accountId = this.currentAccountId;
        
        // Step 1: Get inbox ID (from selected inbox, route params, or first WhatsApp inbox)
        let inboxId = this.selectedInbox || this.$route.params.inboxId;
        
        // If no inboxId, get first WhatsApp inbox
        if (!inboxId && this.whatsappInboxes && this.whatsappInboxes.length > 0) {
          inboxId = this.whatsappInboxes[0].id;
          this.selectedInbox = inboxId;
        }

        if (!inboxId) {
          console.log('No WhatsApp inbox found');
          return;
        }

        // Step 2: Fetch inbox data
        const inbox = await this.$store.dispatch(
          'whatsappTemplates/fetchInboxChannelApiKey',
          {
            inboxId: inboxId,
            access_token: access_token,
            accountId: accountId,
          }
        );
        if (!inbox) {
          console.log('Inbox Not Getting');
          return;
        }

        // Step 3: Sync templates from WhatsApp Graph API to local database
        try {
          await this.syncWhatsappTemplate(inboxId);
        } catch (syncError) {
          console.error('Error syncing WhatsApp templates:', syncError);
        }

        // Step 4: Fetch templates from local database with pagination (reset to page 1 after sync)
        this.currentPage = 1;
        const keys = await this.getKeys();
        const response = await this.$store.dispatch(
          'whatsappTemplates/fetchTemplates',
          {
            inbox: inbox,
            keys: keys,
            accountId: this.$route.params.accountId,
            page: 1,
            perPage: this.perPage,
            status: this.activeFilter,
            search: this.searchQuery,
          }
        );

        if (response?.data?.data) {
          this.templates = response.data.data.map(template => ({
            id: template.id,
            db_id: template.db_id,
            name: template.name,
            language: template.language,
            status: template.status,
            category: template.category,
          }));
          
          if (response.data.meta) {
            this.currentPage = response.data.meta.current_page;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.hasNextPage = response.data.meta.has_next_page;
            this.hasPrevPage = response.data.meta.has_prev_page;
          }
        }
      } finally {
        this.isSyncing = false;
        this.initialLoadComplete = true;
      }
    },

    inboxId() {
      return this.$route.params.inboxId || this.selectedInbox;
    },

    async viewCategory(id) {
      try {
        this.dynamicText = 'Viewing Templates....';
        const keys = await this.getKeys();

        await this.$store.dispatch('whatsappTemplates/ViewForm', {
          id: id,
          keys: keys,
          inboxId: this.inboxId(),
          accountId: this.$route.params.accountId,
        });
        this.$router.push({
          path: this.editTemplatesUrl(id),
          query: { returnTo: this.$route.fullPath },
        });
      } catch (err) {
        console.log('Error While Viewing The data', err);
      } finally {
        this.dynamicText = '';
      }
    },

    editTemplatesUrl(templateId) {
      const baseUrl = `/app/accounts/${this.$route.params.accountId}/settings/inboxes/${this.inboxId()}/whatsapp_template/edit/${templateId}`;
      
      // Add query parameter to indicate the source context
      const isStandaloneContext = !this.$route.params.inboxId;
      if (isStandaloneContext) {
        return `${baseUrl}?standalone=true`;
      }
      
      return baseUrl;
    },
    // async deleteTemplate(name){
    //   try{
    //     this.deletebutton=true;
    //     const inbox = await this.fetchInboxChannelApiKey();
    //     const keys = await this.getKeys()
    //     const response = await axios.delete(
    //       `https://graph.facebook.com/v20.0/${inbox.data.provider_config.business_account_id}/message_templates?name=${name}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${keys.whatsapp_secret_key}`,
    //           'Content-Type': 'application/json',
    //         },
    //       }
    //     );
    //     if (response.status === 200) {
    //       this.showAlert(
    //       'template deleted successfully'
    //       )
    //     }else{
    //       this.showAlert(
    //       'template not deleted'
    //     )
    //     }
    //     this.fetchTemplates();
    //   }catch(error){
    //     console.error("Error while delete the TEmplate",error);
    //   }
    //   finally{
    //     this.deletebutton=false;
    //   }
    // },
    // Delete modal methods
    async openDeleteModal(template) {
      this.selectedTemplateForDelete = template;
      this.templateUsage = null;
      this.showDeleteModal = true;
      
      // Check template usage before showing the modal
      await this.checkTemplateUsage(template);
    },
    async checkTemplateUsage(template) {
      try {
        this.isCheckingUsage = true;
        const inboxId = this.inboxId();
        const access_token = this.currentUser.access_token;
        const accountId = this.currentAccountId;
        
        const inbox = await this.$store.dispatch(
          'whatsappTemplates/fetchInboxChannelApiKey',
          {
            inboxId: inboxId,
            access_token: access_token,
            accountId: accountId,
          }
        );
        
        const response = await this.$store.dispatch(
          'whatsappTemplates/checkTemplateUsage',
          {
            channelId: inbox?.data?.channel_id,
            templateId: template.db_id,
            accountId: this.$route.params.accountId,
          }
        );
        
        if (response?.data?.usage) {
          this.templateUsage = response.data.usage;
        }
      } catch (error) {
        console.error('Error checking template usage:', error);
      } finally {
        this.isCheckingUsage = false;
      }
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.selectedTemplateForDelete = null;
      this.templateUsage = null;
    },
    async confirmDeleteTemplate() {
      if (!this.selectedTemplateForDelete) return;
      
      try {
        this.isDeleting = true;
        this.dynamicText = 'Archiving Template....';
        const templateId = this.selectedTemplateForDelete.db_id;
        const inboxId = this.inboxId();
        const access_token = this.currentUser.access_token;
        const accountId = this.currentAccountId;
        
        const inbox = await this.$store.dispatch(
          'whatsappTemplates/fetchInboxChannelApiKey',
          {
            inboxId: inboxId,
            access_token: access_token,
            accountId: accountId,
          }
        );
        
        const response = await this.$store.dispatch(
          'whatsappTemplates/softDeleteTemplate',
          {
            channelId: inbox?.data?.channel_id,
            templateId: templateId,
            accountId: this.$route.params.accountId,
          }
        );
        
        if (response?.data?.success) {
          this.showAlert('Template archived successfully');
          this.closeDeleteModal();
          
          // If this was the last template on the page and we're not on page 1,
          // go back to the previous page
          if (this.templates.length === 1 && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
          }
          
          this.fetchTemplates(this.currentPage);

          // Refetch inboxes to update cached message_templates used by
          // the "Send WhatsApp Template" dialog so archived templates
          // no longer appear there
          this.$store.dispatch('inboxes/refetch');
        } else {
          this.showAlert('Template not archived');
        }
      } catch (error) {
        console.error('Error while archiving the Template', error);
        this.showAlert('Error archiving template');
      } finally {
        this.isDeleting = false;
        this.dynamicText = '';
      }
    },
    async getSecretKeys() {
      const res = await this.getKeys()
    },
    async restoreTemplate(template) {
      try {
        this.dynamicText = 'Restoring Template....';
        const inboxId = this.inboxId();
        const access_token = this.currentUser.access_token;
        const accountId = this.currentAccountId;
        
        // Fetch inbox channel API key first (to get channel_id if needed)
        const inbox = await this.$store.dispatch(
          'whatsappTemplates/fetchInboxChannelApiKey',
          {
            inboxId: inboxId,
            access_token: access_token,
            accountId: accountId,
          }
        );
        
        const response = await this.$store.dispatch(
          'whatsappTemplates/restoreTemplate',
          {
            channelId: inbox?.data?.channel_id,
            templateId: template.db_id,
            accountId: this.$route.params.accountId,
          }
        );
        
        if (response?.data?.success) {
           this.showAlert('Template restored successfully');
           this.fetchTemplates(this.currentPage);
           // Also refresh inboxes to update any lists
           this.$store.dispatch('inboxes/refetch');
        } else {
           this.showAlert('Template not restored');
        }
      } catch (error) {
        console.error('Error restoring template:', error);
        this.showAlert('Error restoring template');
      } finally {
        this.dynamicText = '';
      }
    },
    async syncWhatsappTemplate(inboxId) {
      try {
        // Use passed inboxId or fallback to route params
        const resolvedInboxId = inboxId || this.$route.params.inboxId;
        const accountId = this.$route.params.accountId || this.currentAccountId;
        
        if (!resolvedInboxId) {
          console.warn('No inbox ID available for sync');
          return;
        }

        const response = await axios.get(
          `/api/v1/accounts/${accountId}/inboxes/${resolvedInboxId}/sync_templates`,
          {
            headers: {
              api_access_token: this.currentUser.access_token,
              'Content-Type': 'application/json',
            },
          }
        );
        return response;
      } catch (error) {
        console.error('Error syncing WhatsApp template:', error);
        throw error;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.divone {
  @apply p-3 bg-white dark:bg-slate-900;
}

// Inbox selector row (separate row when needed)
.inbox-selector-row {
  margin-bottom: 16px;
}

.inbox-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  
  label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    @apply dark:text-slate-300;
  }
}

// Main header with tabs, search, and sync button
.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.sync-button {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;

  ::v-deep(.button) {
    background-color: #40518a;

    &:hover {
      background-color: #344270;
    }
  }
}

.filter-tabs {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 9999px;
  gap: 2px;
  flex-shrink: 0;

  @apply dark:bg-slate-900 dark:border-slate-700;
}

.filter-tab {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  @apply dark:text-slate-300;
  
  &:hover {
    background-color: #f3f4f6;
    color: #374151;
    @apply dark:bg-slate-800 dark:text-slate-200;
  }
  
  &--active {
    background-color: #40518a;
    color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    @apply dark:bg-woot-500;
    
    &:hover {
      background-color: #344270;
      color: white;
      @apply dark:bg-woot-500;
    }
  }
}

.template-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  width: 320px;
  flex-shrink: 1;
  
  .search-icon-wrap {
    position: absolute;
    right: 12px;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    z-index: 1;
  }
  
  .search-icon {
    height: 18px;
    width: 18px;
    color: #94a3b8;
    @apply dark:text-slate-400;
  }
  
  .template-search-input {
    width: 100%;
    height: 38px;
    padding: 0 40px 0 12px;
    font-size: 13px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background: white;
    margin: 0;
    
    @apply dark:bg-slate-800 dark:border-slate-600 dark:text-slate-200;
    
    &::placeholder {
      color: #9ca3af;
      @apply dark:text-slate-500;
    }
    
    &:focus {
      outline: none;
      border-color: #1f93ff;
      box-shadow: 0 0 0 1px #1f93ff;
    }
  }
}

@media (max-width: 768px) {
  .main-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .header-left {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .filter-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
    justify-content: flex-start;
    
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .template-search-wrap {
    width: 100%;
  }
  
  .sync-button {
    justify-content: center;
  }
}

// Custom Dropdown Styles (matching the third image style)
.custom-dropdown {
  position: relative;
  width: 180px !important;
  
  .dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: all 0.2s ease;
    
    @apply dark:bg-slate-700 dark:border-slate-600 dark:text-slate-200;
    
    &:hover {
      border-color: #1f93ff;
    }
    
    span {
      margin-right: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 160px;
    }
  }
  
  .dropdown-menu {
    position: absolute;
    top: 80%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    min-width: 60px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 10;
    max-height: 145px;
    overflow-y: auto;
    text-align: unset;
    @apply dark:bg-slate-700 dark:border-slate-600;
  }
  
  .dropdown-item {
    padding: 10px 10px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background-color 0.15s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 168px;
    
    @apply dark:text-slate-200;
    
    &:hover {
      background-color: #f5f5f5;
      @apply dark:bg-slate-600;
    }
    
    &.is-selected {
      background-color: #e3f2fd;
      color: #1f93ff;
      font-weight: 500;
      
      @apply dark:bg-slate-500;
    }
    
    &:first-child {
      border-radius: 8px 8px 0 0;
    }
    
    &:last-child {
      border-radius: 0 0 8px 8px;
    }
    
    &:only-child {
      border-radius: 8px;
    }
  }
  
  &.is-open {
    .dropdown-trigger {
      border-color: #1f93ff;
    }
  }
}
.notifications--loader {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.template--loader {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  pointer-events: none;
  cursor: not-allowed;
}
.confirm{
  background-color: #40518a !important;
}

.archive-button {
  background-color: #40518a !important;
  color: white !important;
}

.archive-button:hover {
  background-color: #34426f !important;
}

// Responsive table wrapper
.table-wrapper {
  width: 100%;
  margin-bottom: 16px;
  
  @media (min-width: 769px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

// Contacts-page-style table
table.whatsapp {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: white;
  border: 1px solid #cfd2d6;
  border-radius: 8px;
  overflow: hidden;

  @apply dark:bg-slate-900 dark:border-slate-700;

  thead {
    th {
      padding: var(--space-small, 8px) var(--space-two, 16px);
      font-size: var(--font-size-mini, 12px);
      background-color: #f9fafb;
      border-bottom: 1px solid #cfd2d6;
      border-right: 1px solid #cfd2d6;
      text-align: left;
      font-weight: 600;
      color: #999;
      white-space: nowrap;
      text-transform: uppercase;
      letter-spacing: 1px;
      line-height: 1.3;

      @apply dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700;

      &.text-center {
        text-align: center;
      }

      &:last-child {
        border-right: none;
      }
    }
  }

  tbody {
    tr {
      transition: background-color 0.15s ease;

      &:hover td {
        background-color: #f9fafb;
        @apply dark:bg-slate-800;
      }

      &:last-child td {
        border-bottom: none;
      }
    }

    td {
      padding: 6px 16px;
      border-bottom: 1px solid #cfd2d6;
      border-right: 1px solid #cfd2d6;
      vertical-align: middle;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      line-height: 1.3;
      color: #333;
      background-color: white;

      @apply dark:text-slate-200 dark:bg-slate-900 dark:border-slate-700;

      &:last-child {
        border-right: none;
      }
    }
  }

  // Mobile responsive styles - Card layout
  @media (max-width: 768px) {
    border: none;
    border-radius: 0;
    
    thead {
      display: none;
    }
    
    tbody {
      tr {
        display: block;
        margin-bottom: 16px;
        border: 1px solid #cfd2d6;
        border-radius: 8px;
        background-color: white;
        @apply dark:border-slate-700 dark:bg-slate-900;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        border: none;
        border-bottom: 1px solid #e5e7eb;
        text-align: right;
        white-space: normal;
        word-break: break-word;
        
        @apply dark:border-slate-700;
        
        &:last-child {
          border-bottom: none;
        }
        
        &::before {
          content: attr(data-label);
          font-weight: 600;
          text-transform: uppercase;
          font-size: 11px;
          color: #6b7280;
          text-align: left;
          letter-spacing: 0.5px;
          @apply dark:text-slate-400;
        }
        
        &.action-cell {
          justify-content: space-between;
          gap: 8px;
          
          &::before {
            content: attr(data-label);
            font-weight: 600;
            text-transform: uppercase;
            font-size: 11px;
            color: #6b7280;
            text-align: left;
            letter-spacing: 0.5px;
            @apply dark:text-slate-400;
          }
          
          .action-buttons {
            display: flex;
            gap: 8px;
          }
        }
      }
    }
  }
}

// Pagination styles
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 20px;
  padding: 0;
  background-color: #f9f9f9;
  border-radius: 8px;
  min-height: 50px;

  @apply dark:bg-slate-800;
}

.table-footer-wrap {
  flex: 1;
  min-width: 0;
}

// Sticky footer at bottom of scroll area (like contacts/article table)
.table-footer-sticky {
  position: fixed;
  right: 0;
  bottom: 0;
  width: calc(100vw - 3.5rem);
  z-index: 3;
  flex-shrink: 0;
  margin-top: auto;
  background: #f9f9f9;
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);

  @apply dark:bg-slate-800 dark:border-slate-700;
}

.per-page-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  
  label {
    font-size: 14px;
    color: #666;
    @apply dark:text-slate-300;
  }
}

::v-deep(.multiselect__content-wrapper) {
  position: static !important;
}

// Delete modal styles
::v-deep(.modal-container) {
  border-radius: 16px;
}

.delete-modal-content {
  .delete-message {
    margin-bottom: 12px;
    font-size: 14px;
    color: #333;
    @apply dark:text-slate-200;
    
    strong {
      font-weight: 600;
    }
  }
  
  .usage-loading {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 6px;
    margin-bottom: 12px;
    @apply dark:bg-slate-800;
  }
  
  .usage-details {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 12px;
    @apply dark:bg-slate-800 dark:border-slate-600;
    
    .usage-section {
      margin-bottom: 12px;
      
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    
    .usage-title {
      font-size: 13px;
      font-weight: 600;
      color: #495057;
      margin-bottom: 8px;
      @apply dark:text-slate-300;
    }
    
    .usage-list {
      list-style: disc;
      padding-left: 20px;
      margin: 0;
      
      li {
        font-size: 13px;
        color: #6c757d;
        margin-bottom: 4px;
        @apply dark:text-slate-400;
      }
    }
  }
  
  .critical-warning {
    padding: 12px;
    background-color: #fff3cd;
    border: 2px solid #ffc107;
    border-radius: 6px;
    color: #856404;
    font-size: 13px;
    line-height: 1.5;
    margin-top: 12px;
    @apply dark:bg-yellow-800 dark:border-yellow-600 dark:text-yellow-100;
    
    strong {
      font-weight: 700;
    }

    .usage-list {
      list-style: disc;
      padding-left: 20px;
      margin: 0;
      
      li {
        font-size: 13px;
        color: #856404;
        margin-bottom: 4px;
        @apply dark:text-yellow-100;
      }
    }
  }
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  font-size: 16px;
  color: #64748b;
  @apply dark:text-slate-400;
}

.inbox-selection-modal {
  overflow-x: hidden;
  
  ::v-deep(.multiselect) {
    width: 100%;
    
    .multiselect__single,
    .multiselect__option > span {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .multiselect__tags {
      overflow: hidden;
    }
  }
}
</style>
